import React from "react";

export function QueTitle({ children }) {
  return <h3 className="que-title">{children}</h3>;
}
export function QueNumber({ children }) {
  return <p className="que-number">{children}</p>;
}

export function Question({ children }) {
  return <h1 className="que-text">{children}</h1>;
}

export function QueInfo({ children }) {
  return <p className="que-info">{children}</p>;
}

export function OptionText({ children }) {
  return <p className="que-option-text">{children}</p>;
}

export function BtnText({ children }) {
  return <span className="que-btn-text">{children}</span>;
}
